<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <f7-actions>
    <f7-actions-group>
      <f7-actions-label>{{ title }}</f7-actions-label>
    </f7-actions-group>
    <f7-actions-group>
      <f7-actions-button @click="$f7.views.main.router.navigate(`/stores/${storeIdProp}/menu-drafts/${menuDraftVariationProp}/edit-question`)">
        <font-awesome-icon icon="edit" style="margin-right: 5px;" />
        編輯選項
      </f7-actions-button>
      <f7-actions-button @click="$f7.views.main.router.navigate(`/stores/${storeIdProp}/menu-drafts/${currentDraft.variation}/duplicate-actions`)">
        <font-awesome-icon :icon="['far', 'copy']" style="margin-right: 5px;" />
        複製選項
      </f7-actions-button>
      <f7-actions-button color="red" @click="deleteQuestionOnClick">
        <font-awesome-icon icon="trash" style="margin-right: 10px;" />
        刪除選項
      </f7-actions-button>
    </f7-actions-group>
  </f7-actions>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'QuestionActionSheet',
  props: {
    storeIdProp: String,
    menuDraftVariationProp: String,
    questionIdProp: String
  },
  computed: {
    ...mapState('menuDraftModule', ['currentElementPath', 'currentDraft']),
    categoryId () { return this.currentElementPath[0].id },
    groupId () { return this.currentElementPath[1].id },
    itemId () { return this.currentElementPath[2].id },
    elementLevel () { return this.currentElementPath.length === 6 ? 5 : 3 },
    questionIndex () { return this.currentElementPath[this.elementLevel].index },
    title () { return this.currentDraft.questions[this.questionIdProp].title }
  },
  methods: {
    ...mapActions('menuDraftModule', ['setCurrentElementPath', 'deleteQuestion']),
    deleteQuestionOnClick () {
      this.$f7.dialog.confirm(`確定要刪除 ${this.title} ?`, '刪除選項', () => {
        this.deleteQuestion({ questionId: this.questionIdProp, index: this.questionIndex, elementLevel: this.elementLevel })
        // this.setCurrentElementPath(this.currentElementPath.slice(0, this.currentElementPath.length - 1))
      })
    }
  }
}
</script>
